import { safeHTML } from '../../../../../../utils/safeHTML';
import { useTranslation } from '../../../../../../translations';

export default function PrizeItem({ image, title }) {
  const { t } = useTranslation();

  return (
    <div className={'drawing-result-modal__prize-item'}>
      <img className={'drawing-result-modal__prize-item-image'} src={image} alt={''} />
      <span className={'drawing-result-modal__prize-item-title'}>{safeHTML(t(title))}</span>
    </div>
  );
}
